import type { Branded } from './branded'
import type { IssueId } from './issue'
import type { PlanId } from './plan'
import type { ProjectId, UserId } from './project'

type EntryId = Branded<string, 'EntryId'>

const entryId = (value: string): EntryId => value as EntryId

const ENTRY_KIND = {
	JOURNAL: 'journal',
	DOC: 'doc',
	LOG: 'log',
	RESOLUTION: 'resolution',
	HANDOFF: 'handoff',
} as const

const ENTRY_KINDS = [
	ENTRY_KIND.JOURNAL,
	ENTRY_KIND.DOC,
	ENTRY_KIND.LOG,
	ENTRY_KIND.RESOLUTION,
	ENTRY_KIND.HANDOFF,
] as const

type EntryKind = (typeof ENTRY_KINDS)[number]

type Entry = {
	readonly id: EntryId
	readonly kind: EntryKind
	readonly projectId: ProjectId
	readonly issueId: IssueId | undefined
	readonly planId: PlanId | undefined
	readonly slug: string
	readonly title: string
	readonly body: string
	readonly branch: string
	readonly pr: string
	readonly externalRef: string
	readonly tags: readonly string[]
	readonly createdBy: UserId | undefined
	readonly createdAt: Date
	readonly updatedAt: Date
}

// Journal entries and docs are addressed by slug and listed on their own.
// A log belongs to the ticket it was written against, so it is not one of them.
const ADDRESSABLE_KINDS = [ENTRY_KIND.JOURNAL, ENTRY_KIND.DOC] as const

type AddressableKind = (typeof ADDRESSABLE_KINDS)[number]

const isAddressable = (kind: EntryKind): boolean => kind === ENTRY_KIND.JOURNAL || kind === ENTRY_KIND.DOC

export { ADDRESSABLE_KINDS, ENTRY_KIND, ENTRY_KINDS, entryId, isAddressable }
export type { AddressableKind, Entry, EntryId, EntryKind }
